$(document).ready(function () {
	const $search_button = $('.search-wrap--button');
	const $search_input = $('.input-group--overlay .form-control');
	const $header_logo = $('.custom-logo-link');

	//sub menu button hover accessibility
	$search_input.on('keyup', function (e) {
		if (e.keyCode === 27) {
			// ESC
			$search_input.removeClass('active');
			$header_logo.removeClass('custom-logo-link--mobile-hide');
		}
	});
	$search_button.on('keyup', function (e) {
		if (e.keyCode === 13) {
			// Enter
			$search_input.toggleClass('active').focus();
			$header_logo.toggleClass('custom-logo-link--mobile-hide');
		}
	});

	$search_button.on('click touch', function (e) {
		e.preventDefault();
		e.stopPropagation();
		$search_input.toggleClass('active').focus();
		$header_logo.toggleClass('custom-logo-link--mobile-hide');
		// $('.form-control').focus();
	});
});
